import { Dropdown } from "@curtin-dxp/ui";

export const CourseSelect = (props) => {
    return (
        <Dropdown id={props.id} label={props.label} handleSelection={(e) => props.handleSelection(e, props.id)} selection={({value:props.selection})} options={Courses(props.id)} required={props.id} />
    )
}

function Courses(id) {
    const courses = ["Bachelor of Business Administration (B-BUSADM)", "Bachelor of Computing (B-COMP)", "Bachelor of Engineering (BH-ENGR)", "Bachelor of Information Technology (B-INFTEC)", "Bachelor of Science (Computer Systems and Networking) (B-SCCSNT)", "Bachelor of Science (Data Science) (B-SCNCE)", "Master of Artificial Intelligence (MC-AINTL)"];
    
    return (
        courses.map((option) => (
            {
                value: option
            }
        ))
    );
}